/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CreateConversationMessage200Response } from '../models';
// @ts-ignore
import type { ForwardConversationMessage200Response } from '../models';
// @ts-ignore
import type { GetMessageReactions200Response } from '../models';
// @ts-ignore
import type { GetMessageSeenBy200Response } from '../models';
// @ts-ignore
import type { ListConversationMessages200Response } from '../models';
// @ts-ignore
import type { ListConversationMessagesV2200Response } from '../models';
// @ts-ignore
import type { MessageCreatePayload } from '../models';
// @ts-ignore
import type { MessageForwardPayload } from '../models';
// @ts-ignore
import type { MessageUpdatePayload } from '../models';
// @ts-ignore
import type { ReactionCreatePayload } from '../models';
// @ts-ignore
import type { UpdateConversationMessageReaction200Response } from '../models';
/**
 * ConversationMessageApi - axios parameter creator
 */
export const ConversationMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary createConversationMessage
         * @param {string} conversationId 
         * @param {MessageCreatePayload} messageCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversationMessage: async (conversationId: string, messageCreatePayload: MessageCreatePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('createConversationMessage', 'conversationId', conversationId)
            // verify required parameter 'messageCreatePayload' is not null or undefined
            assertParamExists('createConversationMessage', 'messageCreatePayload', messageCreatePayload)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageCreatePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversationMessage: async (conversationId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('deleteConversationMessage', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('deleteConversationMessage', 'messageId', messageId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteConversationMessageReactions
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversationMessageReactions: async (conversationId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('deleteConversationMessageReactions', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('deleteConversationMessageReactions', 'messageId', messageId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/reaction`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary forwardConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {MessageForwardPayload} messageForwardPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardConversationMessage: async (conversationId: string, messageId: string, messageForwardPayload: MessageForwardPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('forwardConversationMessage', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('forwardConversationMessage', 'messageId', messageId)
            // verify required parameter 'messageForwardPayload' is not null or undefined
            assertParamExists('forwardConversationMessage', 'messageForwardPayload', messageForwardPayload)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/forward`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageForwardPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMessage: async (conversationId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getConversationMessage', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getConversationMessage', 'messageId', messageId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageReactions: async (conversationId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getMessageReactions', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getMessageReactions', 'messageId', messageId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/reactions`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageSeenBy: async (conversationId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('getMessageSeenBy', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getMessageSeenBy', 'messageId', messageId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/seen-by`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary listConversationMessages
         * @param {string} conversationId 
         * @param {string} [timestamp] 
         * @param {string} [cursorId] Message ID used with timestamp as a pagination cursor
         * @param {number} [limit] 
         * @param {boolean} [newer] If true, the messages will be sorted in descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationMessages: async (conversationId: string, timestamp?: string, cursorId?: string, limit?: number, newer?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('listConversationMessages', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (cursorId !== undefined) {
                localVarQueryParameter['cursorId'] = cursorId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (newer !== undefined) {
                localVarQueryParameter['newer'] = newer;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {string} [timestamp] 
         * @param {string} [cursorId] Message ID used with timestamp as a pagination cursor
         * @param {number} [limit] 
         * @param {boolean} [newer] If true, the messages will be sorted in descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationMessagesV2: async (conversationId: string, timestamp?: string, cursorId?: string, limit?: number, newer?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('listConversationMessagesV2', 'conversationId', conversationId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/v2`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (cursorId !== undefined) {
                localVarQueryParameter['cursorId'] = cursorId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (newer !== undefined) {
                localVarQueryParameter['newer'] = newer;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary markConversationMessageAsRead
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConversationMessageAsRead: async (conversationId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('markConversationMessageAsRead', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('markConversationMessageAsRead', 'messageId', messageId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/mark-as-read`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary quoteConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteConversationMessage: async (conversationId: string, messageId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('quoteConversationMessage', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('quoteConversationMessage', 'messageId', messageId)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/quote`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reactToConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {ReactionCreatePayload} reactionCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactToConversationMessage: async (conversationId: string, messageId: string, reactionCreatePayload: ReactionCreatePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('reactToConversationMessage', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('reactToConversationMessage', 'messageId', messageId)
            // verify required parameter 'reactionCreatePayload' is not null or undefined
            assertParamExists('reactToConversationMessage', 'reactionCreatePayload', reactionCreatePayload)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/reaction`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactionCreatePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {MessageUpdatePayload} messageUpdatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversationMessage: async (conversationId: string, messageId: string, messageUpdatePayload: MessageUpdatePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('updateConversationMessage', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('updateConversationMessage', 'messageId', messageId)
            // verify required parameter 'messageUpdatePayload' is not null or undefined
            assertParamExists('updateConversationMessage', 'messageUpdatePayload', messageUpdatePayload)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageUpdatePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary updateConversationMessageReaction
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {ReactionCreatePayload} reactionCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversationMessageReaction: async (conversationId: string, messageId: string, reactionCreatePayload: ReactionCreatePayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'conversationId' is not null or undefined
            assertParamExists('updateConversationMessageReaction', 'conversationId', conversationId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('updateConversationMessageReaction', 'messageId', messageId)
            // verify required parameter 'reactionCreatePayload' is not null or undefined
            assertParamExists('updateConversationMessageReaction', 'reactionCreatePayload', reactionCreatePayload)
            const localVarPath = `/api/nora/chat/conversation/{conversationId}/message/{messageId}/reaction`
                .replace('{conversationId}', encodeURIComponent(String(conversationId)))
                .replace('{messageId}', encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reactionCreatePayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConversationMessageApi - functional programming interface
 */
export const ConversationMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConversationMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary createConversationMessage
         * @param {string} conversationId 
         * @param {MessageCreatePayload} messageCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createConversationMessage(conversationId: string, messageCreatePayload: MessageCreatePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateConversationMessage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createConversationMessage(conversationId, messageCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.createConversationMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConversationMessage(conversationId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConversationMessage(conversationId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.deleteConversationMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteConversationMessageReactions
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteConversationMessageReactions(conversationId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteConversationMessageReactions(conversationId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.deleteConversationMessageReactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary forwardConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {MessageForwardPayload} messageForwardPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forwardConversationMessage(conversationId: string, messageId: string, messageForwardPayload: MessageForwardPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ForwardConversationMessage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forwardConversationMessage(conversationId, messageId, messageForwardPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.forwardConversationMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConversationMessage(conversationId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateConversationMessage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConversationMessage(conversationId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.getConversationMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageReactions(conversationId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMessageReactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageReactions(conversationId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.getMessageReactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageSeenBy(conversationId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMessageSeenBy200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageSeenBy(conversationId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.getMessageSeenBy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary listConversationMessages
         * @param {string} conversationId 
         * @param {string} [timestamp] 
         * @param {string} [cursorId] Message ID used with timestamp as a pagination cursor
         * @param {number} [limit] 
         * @param {boolean} [newer] If true, the messages will be sorted in descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConversationMessages(conversationId: string, timestamp?: string, cursorId?: string, limit?: number, newer?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListConversationMessages200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConversationMessages(conversationId, timestamp, cursorId, limit, newer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.listConversationMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} conversationId 
         * @param {string} [timestamp] 
         * @param {string} [cursorId] Message ID used with timestamp as a pagination cursor
         * @param {number} [limit] 
         * @param {boolean} [newer] If true, the messages will be sorted in descending order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listConversationMessagesV2(conversationId: string, timestamp?: string, cursorId?: string, limit?: number, newer?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListConversationMessagesV2200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listConversationMessagesV2(conversationId, timestamp, cursorId, limit, newer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.listConversationMessagesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary markConversationMessageAsRead
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markConversationMessageAsRead(conversationId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markConversationMessageAsRead(conversationId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.markConversationMessageAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary quoteConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quoteConversationMessage(conversationId: string, messageId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateConversationMessage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quoteConversationMessage(conversationId, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.quoteConversationMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary reactToConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {ReactionCreatePayload} reactionCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reactToConversationMessage(conversationId: string, messageId: string, reactionCreatePayload: ReactionCreatePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateConversationMessageReaction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reactToConversationMessage(conversationId, messageId, reactionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.reactToConversationMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateConversationMessage
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {MessageUpdatePayload} messageUpdatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConversationMessage(conversationId: string, messageId: string, messageUpdatePayload: MessageUpdatePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateConversationMessage200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConversationMessage(conversationId, messageId, messageUpdatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.updateConversationMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary updateConversationMessageReaction
         * @param {string} conversationId 
         * @param {string} messageId 
         * @param {ReactionCreatePayload} reactionCreatePayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateConversationMessageReaction(conversationId: string, messageId: string, reactionCreatePayload: ReactionCreatePayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateConversationMessageReaction200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateConversationMessageReaction(conversationId, messageId, reactionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConversationMessageApi.updateConversationMessageReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConversationMessageApi - factory interface
 */
export const ConversationMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConversationMessageApiFp(configuration)
    return {
        /**
         * 
         * @summary createConversationMessage
         * @param {ConversationMessageApiCreateConversationMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConversationMessage(requestParameters: ConversationMessageApiCreateConversationMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateConversationMessage200Response> {
            return localVarFp.createConversationMessage(requestParameters.conversationId, requestParameters.messageCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteConversationMessage
         * @param {ConversationMessageApiDeleteConversationMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversationMessage(requestParameters: ConversationMessageApiDeleteConversationMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteConversationMessage(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteConversationMessageReactions
         * @param {ConversationMessageApiDeleteConversationMessageReactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteConversationMessageReactions(requestParameters: ConversationMessageApiDeleteConversationMessageReactionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteConversationMessageReactions(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary forwardConversationMessage
         * @param {ConversationMessageApiForwardConversationMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forwardConversationMessage(requestParameters: ConversationMessageApiForwardConversationMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<ForwardConversationMessage200Response> {
            return localVarFp.forwardConversationMessage(requestParameters.conversationId, requestParameters.messageId, requestParameters.messageForwardPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getConversationMessage
         * @param {ConversationMessageApiGetConversationMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConversationMessage(requestParameters: ConversationMessageApiGetConversationMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateConversationMessage200Response> {
            return localVarFp.getConversationMessage(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConversationMessageApiGetMessageReactionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageReactions(requestParameters: ConversationMessageApiGetMessageReactionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMessageReactions200Response> {
            return localVarFp.getMessageReactions(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConversationMessageApiGetMessageSeenByRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageSeenBy(requestParameters: ConversationMessageApiGetMessageSeenByRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMessageSeenBy200Response> {
            return localVarFp.getMessageSeenBy(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary listConversationMessages
         * @param {ConversationMessageApiListConversationMessagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationMessages(requestParameters: ConversationMessageApiListConversationMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListConversationMessages200Response> {
            return localVarFp.listConversationMessages(requestParameters.conversationId, requestParameters.timestamp, requestParameters.cursorId, requestParameters.limit, requestParameters.newer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConversationMessageApiListConversationMessagesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConversationMessagesV2(requestParameters: ConversationMessageApiListConversationMessagesV2Request, options?: RawAxiosRequestConfig): AxiosPromise<ListConversationMessagesV2200Response> {
            return localVarFp.listConversationMessagesV2(requestParameters.conversationId, requestParameters.timestamp, requestParameters.cursorId, requestParameters.limit, requestParameters.newer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary markConversationMessageAsRead
         * @param {ConversationMessageApiMarkConversationMessageAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markConversationMessageAsRead(requestParameters: ConversationMessageApiMarkConversationMessageAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.markConversationMessageAsRead(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary quoteConversationMessage
         * @param {ConversationMessageApiQuoteConversationMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quoteConversationMessage(requestParameters: ConversationMessageApiQuoteConversationMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateConversationMessage200Response> {
            return localVarFp.quoteConversationMessage(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reactToConversationMessage
         * @param {ConversationMessageApiReactToConversationMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reactToConversationMessage(requestParameters: ConversationMessageApiReactToConversationMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateConversationMessageReaction200Response> {
            return localVarFp.reactToConversationMessage(requestParameters.conversationId, requestParameters.messageId, requestParameters.reactionCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateConversationMessage
         * @param {ConversationMessageApiUpdateConversationMessageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversationMessage(requestParameters: ConversationMessageApiUpdateConversationMessageRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateConversationMessage200Response> {
            return localVarFp.updateConversationMessage(requestParameters.conversationId, requestParameters.messageId, requestParameters.messageUpdatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary updateConversationMessageReaction
         * @param {ConversationMessageApiUpdateConversationMessageReactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConversationMessageReaction(requestParameters: ConversationMessageApiUpdateConversationMessageReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateConversationMessageReaction200Response> {
            return localVarFp.updateConversationMessageReaction(requestParameters.conversationId, requestParameters.messageId, requestParameters.reactionCreatePayload, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createConversationMessage operation in ConversationMessageApi.
 */
export interface ConversationMessageApiCreateConversationMessageRequest {
    readonly conversationId: string

    readonly messageCreatePayload: MessageCreatePayload
}

/**
 * Request parameters for deleteConversationMessage operation in ConversationMessageApi.
 */
export interface ConversationMessageApiDeleteConversationMessageRequest {
    readonly conversationId: string

    readonly messageId: string
}

/**
 * Request parameters for deleteConversationMessageReactions operation in ConversationMessageApi.
 */
export interface ConversationMessageApiDeleteConversationMessageReactionsRequest {
    readonly conversationId: string

    readonly messageId: string
}

/**
 * Request parameters for forwardConversationMessage operation in ConversationMessageApi.
 */
export interface ConversationMessageApiForwardConversationMessageRequest {
    readonly conversationId: string

    readonly messageId: string

    readonly messageForwardPayload: MessageForwardPayload
}

/**
 * Request parameters for getConversationMessage operation in ConversationMessageApi.
 */
export interface ConversationMessageApiGetConversationMessageRequest {
    readonly conversationId: string

    readonly messageId: string
}

/**
 * Request parameters for getMessageReactions operation in ConversationMessageApi.
 */
export interface ConversationMessageApiGetMessageReactionsRequest {
    readonly conversationId: string

    readonly messageId: string
}

/**
 * Request parameters for getMessageSeenBy operation in ConversationMessageApi.
 */
export interface ConversationMessageApiGetMessageSeenByRequest {
    readonly conversationId: string

    readonly messageId: string
}

/**
 * Request parameters for listConversationMessages operation in ConversationMessageApi.
 */
export interface ConversationMessageApiListConversationMessagesRequest {
    readonly conversationId: string

    readonly timestamp?: string

    /**
     * Message ID used with timestamp as a pagination cursor
     */
    readonly cursorId?: string

    readonly limit?: number

    /**
     * If true, the messages will be sorted in descending order
     */
    readonly newer?: boolean
}

/**
 * Request parameters for listConversationMessagesV2 operation in ConversationMessageApi.
 */
export interface ConversationMessageApiListConversationMessagesV2Request {
    readonly conversationId: string

    readonly timestamp?: string

    /**
     * Message ID used with timestamp as a pagination cursor
     */
    readonly cursorId?: string

    readonly limit?: number

    /**
     * If true, the messages will be sorted in descending order
     */
    readonly newer?: boolean
}

/**
 * Request parameters for markConversationMessageAsRead operation in ConversationMessageApi.
 */
export interface ConversationMessageApiMarkConversationMessageAsReadRequest {
    readonly conversationId: string

    readonly messageId: string
}

/**
 * Request parameters for quoteConversationMessage operation in ConversationMessageApi.
 */
export interface ConversationMessageApiQuoteConversationMessageRequest {
    readonly conversationId: string

    readonly messageId: string
}

/**
 * Request parameters for reactToConversationMessage operation in ConversationMessageApi.
 */
export interface ConversationMessageApiReactToConversationMessageRequest {
    readonly conversationId: string

    readonly messageId: string

    readonly reactionCreatePayload: ReactionCreatePayload
}

/**
 * Request parameters for updateConversationMessage operation in ConversationMessageApi.
 */
export interface ConversationMessageApiUpdateConversationMessageRequest {
    readonly conversationId: string

    readonly messageId: string

    readonly messageUpdatePayload: MessageUpdatePayload
}

/**
 * Request parameters for updateConversationMessageReaction operation in ConversationMessageApi.
 */
export interface ConversationMessageApiUpdateConversationMessageReactionRequest {
    readonly conversationId: string

    readonly messageId: string

    readonly reactionCreatePayload: ReactionCreatePayload
}

/**
 * ConversationMessageApi - object-oriented interface
 */
export class ConversationMessageApi extends BaseAPI {
    /**
     * 
     * @summary createConversationMessage
     * @param {ConversationMessageApiCreateConversationMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createConversationMessage(requestParameters: ConversationMessageApiCreateConversationMessageRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).createConversationMessage(requestParameters.conversationId, requestParameters.messageCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteConversationMessage
     * @param {ConversationMessageApiDeleteConversationMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConversationMessage(requestParameters: ConversationMessageApiDeleteConversationMessageRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).deleteConversationMessage(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteConversationMessageReactions
     * @param {ConversationMessageApiDeleteConversationMessageReactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteConversationMessageReactions(requestParameters: ConversationMessageApiDeleteConversationMessageReactionsRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).deleteConversationMessageReactions(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary forwardConversationMessage
     * @param {ConversationMessageApiForwardConversationMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public forwardConversationMessage(requestParameters: ConversationMessageApiForwardConversationMessageRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).forwardConversationMessage(requestParameters.conversationId, requestParameters.messageId, requestParameters.messageForwardPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getConversationMessage
     * @param {ConversationMessageApiGetConversationMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getConversationMessage(requestParameters: ConversationMessageApiGetConversationMessageRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).getConversationMessage(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConversationMessageApiGetMessageReactionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMessageReactions(requestParameters: ConversationMessageApiGetMessageReactionsRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).getMessageReactions(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConversationMessageApiGetMessageSeenByRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMessageSeenBy(requestParameters: ConversationMessageApiGetMessageSeenByRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).getMessageSeenBy(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary listConversationMessages
     * @param {ConversationMessageApiListConversationMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConversationMessages(requestParameters: ConversationMessageApiListConversationMessagesRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).listConversationMessages(requestParameters.conversationId, requestParameters.timestamp, requestParameters.cursorId, requestParameters.limit, requestParameters.newer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConversationMessageApiListConversationMessagesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listConversationMessagesV2(requestParameters: ConversationMessageApiListConversationMessagesV2Request, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).listConversationMessagesV2(requestParameters.conversationId, requestParameters.timestamp, requestParameters.cursorId, requestParameters.limit, requestParameters.newer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary markConversationMessageAsRead
     * @param {ConversationMessageApiMarkConversationMessageAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markConversationMessageAsRead(requestParameters: ConversationMessageApiMarkConversationMessageAsReadRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).markConversationMessageAsRead(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary quoteConversationMessage
     * @param {ConversationMessageApiQuoteConversationMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public quoteConversationMessage(requestParameters: ConversationMessageApiQuoteConversationMessageRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).quoteConversationMessage(requestParameters.conversationId, requestParameters.messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reactToConversationMessage
     * @param {ConversationMessageApiReactToConversationMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reactToConversationMessage(requestParameters: ConversationMessageApiReactToConversationMessageRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).reactToConversationMessage(requestParameters.conversationId, requestParameters.messageId, requestParameters.reactionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateConversationMessage
     * @param {ConversationMessageApiUpdateConversationMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConversationMessage(requestParameters: ConversationMessageApiUpdateConversationMessageRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).updateConversationMessage(requestParameters.conversationId, requestParameters.messageId, requestParameters.messageUpdatePayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary updateConversationMessageReaction
     * @param {ConversationMessageApiUpdateConversationMessageReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateConversationMessageReaction(requestParameters: ConversationMessageApiUpdateConversationMessageReactionRequest, options?: RawAxiosRequestConfig) {
        return ConversationMessageApiFp(this.configuration).updateConversationMessageReaction(requestParameters.conversationId, requestParameters.messageId, requestParameters.reactionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
}

